var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartmentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 8V13.8333",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37533 7.58317C5.8711 7.58317 7.08366 6.37061 7.08366 4.87484C7.08366 3.37907 5.8711 2.1665 4.37533 2.1665C2.87955 2.1665 1.66699 3.37907 1.66699 4.87484C1.66699 6.37061 2.87955 7.58317 4.37533 7.58317Z",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 18.8335C5.5477 18.8335 6.66699 17.7142 6.66699 16.3335C6.66699 14.9528 5.5477 13.8335 4.16699 13.8335C2.78628 13.8335 1.66699 14.9528 1.66699 16.3335C1.66699 17.7142 2.78628 18.8335 4.16699 18.8335Z",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 18.8335C17.2137 18.8335 18.333 17.7142 18.333 16.3335C18.333 14.9528 17.2137 13.8335 15.833 13.8335C14.4523 13.8335 13.333 14.9528 13.333 16.3335C13.333 17.7142 14.4523 18.8335 15.833 18.8335Z",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27539 8C4.65039 9.45833 5.98372 10.5417 7.55872 10.5333L10.4171 10.525C11.1171 10.525 11.7754 10.6667 12.3837 10.9167",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentsIcon);
export default __webpack_public_path__ + "static/media/departmentsIcon.7a5570dd19d72d95638754226c82e20d.svg";
export { ForwardRef as ReactComponent };